const getProjectConfig = (PROJECT_KEY) => {
    if (!PROJECT_KEY || PROJECT_KEY === '001') {
        return {
            projectName: 'AteaseKart',
            secretKey: `!atease@1234#${PROJECT_KEY}`,
            logoUrl: process.env.PUBLIC_URL + `/logo.png`,
            bgColor: "bg-primary-blue",
        }
    }
    if (PROJECT_KEY === 'JJD') {
        return {
            projectName: 'J J Distributors',
            secretKey: `!atease@1234#${PROJECT_KEY}`,
            logoUrl: process.env.PUBLIC_URL + `/logo.png`,
            bgColor: "bg-primary-teal"
        }
    }
}

export const PROJECT_KEY = process.env.REACT_APP_PROJECT_KEY || '001'
export const PROJECT_NAME = getProjectConfig(PROJECT_KEY).projectName
export const SECRET_KEY = getProjectConfig(PROJECT_KEY).secretKey
export const FCM_VAPID = 'BGFMRf2uCKXNDtUYhMlh5uPFS6X6iok6wI6o4ktPjPQp6kUqUkDgCZyYuZUp9n9iRJhXRRLgNsZrIkYXYvRTRW8'
export const getLogoUrl = getProjectConfig(PROJECT_KEY).logoUrl
export const BACKGROUND_COLOR = getProjectConfig(PROJECT_KEY).bgColor